const ViewAllIcon = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0476 5.28581L5.61926 14.7141M15.4176 13.9441V6.19748C15.4184 6.02899 15.3857 5.86202 15.3216 5.70622C15.2574 5.55042 15.1631 5.40887 15.0439 5.28977C14.9247 5.17067 14.7831 5.07637 14.6273 5.01233C14.4714 4.94828 14.3044 4.91576 14.1359 4.91664H6.38926"
        stroke="#4A4CCD"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export default ViewAllIcon;
